import React, { useContext, Suspense } from "react";
import { CommunicationContext } from "../../contexts/CommunicationContext";
import * as Component from "@unlimited-robotics/ur-ui-kit";
import PageOutline from "../../components/page-outline/PageOutline";
import { WithoutSidebarWrapper } from "./components";
import { mapAssetSrc } from "helpers/mapAssetSrc";

// Dynamically import TestingPanel only in dev mode
const TestingPanel = process.env.REACT_APP_DEV_MODE
  ? React.lazy(() => import("../../components/TestingPanel"))
  : null;

const SidebarWraper = ({ children, showSidebar, app_id }) => {
  return showSidebar ? (
    <PageOutline header={{ title: app_id || "" }}>{children}</PageOutline>
  ) : (
    <WithoutSidebarWrapper>{children}</WithoutSidebarWrapper>
  );
};

const DynamicAppPage = () => {
  const { components, sendMessage, setErrors, defaultComponent } = useContext(CommunicationContext);

  const renderComponent = (componentData) => {
    console.log("🚀 ~ renderComponent ~ componentData:", componentData);
    const ComponentToRender = Component[componentData.component];

    if (!ComponentToRender) {
      setErrors({
        component: `component ${componentData.component} does not exist `,
      });
      return null;
    }

    return (
      <ComponentToRender
        key={componentData.uid}
        mapAssetSrc={mapAssetSrc}
        callback={sendMessage}
        uid={componentData.uid}
        {...componentData.data}
      />
    );
  };

  return (
    <>
      <SidebarWraper>
        {/* Base component (lowest priority) */}
        {!components.length && renderComponent(defaultComponent)}

        {/* Render components in priority order */}
        {components.map((componentData, index) => (
          <div
            key={componentData.uid}
            style={{
              position: index === 0 ? "relative" : "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 100 + componentData.priority,
            }}
          >
            {renderComponent(componentData)}
          </div>
        ))}
      </SidebarWraper>

      {/* Testing Panel Overlay - Only in dev mode */}
      {process.env.REACT_APP_DEV_MODE && TestingPanel && (
        <Suspense
          fallback={
            <div
              style={{
                position: "fixed",
                top: "20px",
                right: "20px",
                color: "white",
                background: "rgba(0,0,0,0.8)",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              Loading Test Panel...
            </div>
          }
        >
          <TestingPanel />
        </Suspense>
      )}
    </>
  );
};

export default DynamicAppPage;
